<template>
  <div
    class="p-5 border border-exitos border-dashed rounded-sm d-inline-flex align-items-center justify-content-center w-100"
  >
    <div class="d-inline-flex flex-column align-items-center my-4">
      <font-awesome-icon
        icon="cloud-arrow-up"
        class="display-3 text-exitos mb-1"
        :beat="dropping"
        :fade="dropping"
      />
      <h4 class="mb-1 text-exitos">Arraste o arquivo XLSX</h4>
      <p class="small text-gray mb-0">
        O arquivo deve conter: CNPJ, IBGE, Município e UF.
      </p>
      <small class="text-gray">
        *Você também pode clicar aqui para escolher os arquivos
      </small>
      <b-button
        size="sm"
        variant="exitos"
        class="mt-3"
        :disabled="disabled"
        @click="$emit('open')"
      >
        Selecionar arquivo
      </b-button>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    dropping: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["open"],
});
</script>
<style scoped lang="scss">
.line {
  min-width: 30px;
  flex-shrink: 0;
}

.border-dashed {
  border-style: dashed !important;
}
</style>
